import { createClient } from '@supabase/supabase-js'
import type { Database } from '@/types/database'
import { env, isSupabaseConfigured } from './env'

/**
 * Cliente Supabase (browser). Usa SOMENTE a anon key.
 * A proteção dos dados é a RLS no Postgres, não o segredo desta chave.
 *
 * Se as variáveis não estiverem configuradas, criamos um cliente "placeholder"
 * para o app poder renderizar a tela de setup em vez de quebrar no import.
 */
const supabaseUrl = isSupabaseConfigured ? env.supabaseUrl : 'http://localhost:54321'
const supabaseAnonKey = isSupabaseConfigured ? env.supabaseAnonKey : 'public-anon-placeholder'

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
    storageKey: 'texa-hub-auth',
  },
  global: {
    headers: { 'x-application-name': 'texa-hub' },
  },
})

export type SupabaseClient = typeof supabase
